import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Form } from '../../entities/control-tables/form';

export class FormRequest extends BaseRequest {
  form : Form;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.form = new Form();
  }
}